import React from 'react';
import {withRouter} from 'react-router-dom';
import ContentTemplate from '../ContentTemplate';

// the PSP return urls are built in donations/server saveOnlinePayment
const failedActions = ['fail', 'cancel', 'error'];

function PaymentFailedMessage({formContext, location}) {
  const action = new URLSearchParams(location.search).get('action');

  if (!failedActions.includes(action)) {
    return null;
  }

  return (
    <ContentTemplate
      html={formContext.paymentFailedTemplate}
      formContext={formContext}
      contentKey='paymentFailed' />
  );
}

export default withRouter(PaymentFailedMessage);
